// import { Button } from '@material-ui/core';
import React from 'react';
import { Link } from 'react-router-dom';
import { CardTag } from '../index';

export const Banner = ({
  type = 'split',
  background = '',
  bgColor = '',
  caption = 'Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum',
  topLabel = false,
  tag = false,
  hasBtn = false,
  btnText = '',
  className = '',
}) => (
  <div
    className={`banner-container ${className} ${bgColor || ''}`}
    data-bg={background || ''}
    style={background ? { background: `url(${background})`, backgroundSize: '100% 100%', backgroundRepeat: 'no-repeat' } : {}}>
    {topLabel && <label>{topLabel}</label>}
    {tag && (
      <div className="d-flex justify-content-start">
        <CardTag color="purple" text="CHILD HELP" />
      </div>
    )}
    {type === 'split' && (
    <>
      <div>
        <h1 className="text-white text-bold  my-3">
          {caption}
        </h1>
        {hasBtn && (
          <div className="">
            <Link to="/updates">
              <div className="primary-btn green p-3 text-white text-center cursor-pointer">VIEW ALL UPDATES</div>
            </Link>
          </div>
        )}
      </div>
    </>
    )}
  </div>
);
 
export default Banner;
